export default {"src":"/_next/static/media/fotografia.61badba9.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};